import React, { Component } from 'react';
import PropTypes from 'prop-types';
import KnolskapeIconIntro from './../../globals/images/for-intro.png';
import KnolskapeIcon from './../../globals/images/for-white-bg.png';
import getLabel from './../../utils/labels'
import styles from './footer.module.scss';

class Footer extends Component {
    render() {
        let { isIntro } = this.props;
        let icon = isIntro ? KnolskapeIconIntro : KnolskapeIcon;

        return (
            <footer
                className={styles.container}
                style={isIntro ? { backgroundColor: 'rgba(255,255,255,0)', color: 'white' } : {}}
            >
                <div className={styles.wrapper}>
                    {/* <div >Copyright</div>
                    <img src={icon} className={styles.logo} /> */}
                    <div>{getLabel('label_copyright')}</div>
                </div>
            </footer>
        )
    }
}

Footer.propTypes = {
    timeData: PropTypes.object
};

Footer.defaultProps = {
    timeData: {}
}

export default Footer;


// WEBPACK FOOTER //
// /src/components/footer/Footer.js